import styles from '@jobcase/react_pattern_library/styles/rebrand';

export const TABS = {
  OVERVIEW: 'overview',
  SUB_ORGANIZATIONS: 'sub_organizations',
  MARKETING: 'marketing',
  ADMIN: 'admin',
};

export const TABS_TITLES = {
  overview: 'Overview',
  sub_organizations: 'Sub Organizations',
  marketing: 'Marketing',
  admin: 'Admin',
};

export const SORT_OPTIONS = [
  {
    label: 'Sub org name A-Z',
    value: 'name&false',
  },
  {
    label: 'Sub org name Z-A',
    value: 'name&true',
  },
  {
    label: 'Newest created date',
    value: 'created_at&true',
  },
  {
    label: 'Oldest created date',
    value: 'created_at&false',
  },
];

export const SUB_ORGANIZATIONS_TABS = {
  OVERVIEW: 'overview',
  CREDIT_CARDS: 'credit_cards',
  MARKETING: 'marketing',
};

export const SUB_ORGANIZATIONS_TABS_TITLES = {
  overview: 'Overview',
  credit_cards: 'Credit cards',
  marketing: 'Marketing',
};

export const DELETE_SUB_ORGANIZATION_PROMPT = {
  headerText: 'Delete sub org?',
  bodyText: 'Any information or files you’ve added to this sub org will be deleted.',
  primaryButtonText: 'Delete',
  showSecondaryButton: true,
  secondaryButtonText: 'Back',
  className: 'delete-confirmation-modal',
};

export const ERROR_DELETE_SUB_ORGANIZATION_PROMPT = {
  headerText: 'This sub org can’t be deleted.',
  bodyText: 'You must reassign any associated job groups before deleting this sub org.',
  primaryButtonText: 'OK',
  className: 'delete-confirmation-modal',
};

export const ASSETS_TYPE = {
  HIRING_EVENT: 'HIRING_EVENT',
  HUB: 'HUB',
  JOB: 'JOB',
  PROMOTIONAL: 'PROMOTIONAL',
};

export const ASSETS_ENTITY_TYPE = {
  HIRING_EVENT: 'ORGANIZATION_HIRING_EVENT',
  HUB: 'ORGANIZATION_HUB',
  JOB: 'ORGANIZATION_JOB',
};

export const OPENINGS_PER_YEAR = [
  {
    key: 'LESS_THAN_26',
    title: '25 or less per year',
  },
  {
    key: 'GREATER_THAN_26_TO_50',
    title: '26-50 per year',
  },
  {
    key: 'GREATER_THAN_50',
    title: '51+ per year',
  },
  {
    key: 'GREATER_THAN_26_TO_100',
    title: '26-100 per year',
  },
  {
    key: 'GREATER_THAN_100',
    title: '101+ per year',
  },
];

export const COMPANY_SCALE = {
  SMALL: 'LESS_THAN_26',
  MID: 'GREATER_THAN_26_TO_50',
  LARGE: 'GREATER_THAN_50',
};

export const ORGANIZATION_STATUS_COLOR_MAP = {
  APPROVED: styles.color.lightSuccessColor,
  PENDING: styles.color.lightBlueColor,
  REJECTED: styles.color.lightErrorColor,
  PENDING_REQUEST_VERIFICATION: styles.color.mediumYellowColor,
};

export const ORGANIZATION_STATUS_READABLE_MAP = {
  APPROVED: 'Approved',
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  PENDING_REQUEST_VERIFICATION: 'Pending Verification',
};

export const ORGANIZATION_STATUS_OPTIONS = [
  {
    key: 'PENDING',
    title: 'Pending',
    hovered: false,
  },
  {
    key: 'PENDING_REQUEST_VERIFICATION',
    title: 'Pending: Request Verification',
    hovered: false,
  },
  {
    key: 'APPROVED',
    title: 'Approved',
    hovered: false,
  },
  {
    key: 'REJECTED',
    title: 'Rejected',
    hovered: false,
  },
];

export const ORGANIZATION_STATUS = {
  PENDING: 'PENDING',
  PENDING_REQUEST_VERIFICATION: 'PENDING_REQUEST_VERIFICATION',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const SALES_TEAM_OPTIONS = [
  {
    key: 1,
    title: 'Direct Sales',
    value: 'DIRECT_SALES',
    hovered: false,
  },
  {
    key: 2,
    title: 'Agency',
    value: 'AGENCY',
    hovered: false,
  },
  {
    key: 3,
    title: 'Staffing/RPO',
    value: 'STAFFING_RPO',
    hovered: false,
  },
  {
    key: 4,
    title: 'SMB',
    value: 'SMB',
    hovered: false,
  },
  {
    key: 5,
    title: 'Self Service',
    value: 'SELF_SERVICE',
    hovered: false,
  },
];

export const MARKETING_ASSETS_TYPE = {
  ORG_MARKETING_ASSETS: 'org_marketing_assets',
  SUB_ORG_MARKETING_ASSETS: 'sub_org_marketing_assets',
  HIRING_EVENTS_ASSETS: 'hiring_events_assets',
};

export default {
  SUB_ORGANIZATIONS_TABS,
  SUB_ORGANIZATIONS_TABS_TITLES,
  SORT_OPTIONS,
  TABS,
  TABS_TITLES,
  DELETE_SUB_ORGANIZATION_PROMPT,
  ERROR_DELETE_SUB_ORGANIZATION_PROMPT,
  ASSETS_TYPE,
  ASSETS_ENTITY_TYPE,
  OPENINGS_PER_YEAR,
  COMPANY_SCALE,
  ORGANIZATION_STATUS_OPTIONS,
  SALES_TEAM_OPTIONS,
  ORGANIZATION_STATUS_COLOR_MAP,
  ORGANIZATION_STATUS_READABLE_MAP,
  MARKETING_ASSETS_TYPE,
};
